import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState, useMemo } from 'react';
import { Surface } from '../../atoms';
const parseDate = (date) => {
    if (date instanceof Date) {
        const year = date.getFullYear().toString();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    return date;
};
// TODO: this is currently an uncontrolled component
// passed value will only be used as initial value
const DateInput = (props) => {
    const [dateString, setDateString] = useState(() => parseDate(props.value) ?? '');
    const date = useMemo(() => new Date(dateString), [dateString]);
    useEffect(() => {
        if (dateString === '' || dateString === undefined) {
            props.onChangeDate?.(undefined);
        }
        if (dateString?.match(/^\d{4}-\d{2}-\d{2}$/) && parseInt(dateString.slice(0, 4)) >= 1000) {
            props.onChangeDate?.(date);
        }
    }, 
    // Can enter infinite loop if unstable deps is passed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [date]);
    useEffect(() => {
        if (props.min !== undefined && date < new Date(props.min)) {
            setDateString(parseDate(props.min) ?? '');
        }
        if (props.max !== undefined && date > new Date(props.max)) {
            setDateString(parseDate(props.max) ?? '');
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [date, props.max?.toString(), props.min?.toString()]);
    return (
    // @ts-expect-error
    _jsx(Surface, { as: "input", ...props, value: dateString, min: parseDate(props.min), max: parseDate(props.max), type: "date", onChange: event => {
            props.onChange?.(event);
            setDateString(event.target.value);
        }, css: {
            outline: 'none',
            border: 'none',
            padding: '1.6rem',
            borderRadius: '0.8rem',
            colorScheme: 'dark',
        } }));
};
export default DateInput;
//# sourceMappingURL=DateInput.js.map